<form name="createRole" (ngSubmit)="createRole()" #createRoleForm="ngForm" method="post" class="container pt-5">

    <div class="card text-bg-secondary mb-3 create-role-card">
        <div class="card-body">
            <div class="container">
                <div class="mb-3">
                    <h1 class="card-header ps-0">Create New Role</h1>
                </div>
                <div class="mb-3">
                    <div id="errorSummary" class="text-danger" [innerHTML]="errorList.outerHTML"></div>
                    <label for="roleName" class="form-label">Role</label>
                    <input type="text"
                           class="form-control"
                           id="roleName"
                           name="roleName"
                           placeholder="Name"
                           [(ngModel)]="model.roleName"
                           #roleName="ngModel"
                           [maxlength]="256"
                           [required]="true" />
                    <span id="roleNameErrorMsg"
                          class="text-danger"
                          *ngIf="roleName.invalid && (roleName.dirty || roleName.touched)">
                        <span *ngIf="roleName.errors?.['required']">Role is required.</span>
                        <span *ngIf="roleName.errors?.['maxlength']">
                            The maximum length for role is 256 characters.
                        </span>
                    </span>
                    <span id="serverRoleNameErrorMsg" class="text-danger">
                        {{roleNameErrorMsg}}
                    </span>
                </div>
                <div class="mb-3">
                    <label for="description" class="form-label">Description</label>
                    <textarea id="description"
                              name="description"
                              class="form-control"
                              placeholder="My awesome role is for awesome users."
                              [(ngModel)]="model.description"
                              #description="ngModel"
                              rows="3"></textarea>
                </div>
                <button type="submit" class="btn btn-primary" style="width:auto">
                    Create Role
                </button>
            </div>
        </div>
    </div>
</form>
